Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.MultipleImageUpload = (function () {

    function MultipleImageUpload () {

        Monet.UI.Fields.ImageUpload.apply(this, arguments);

        this.uploadedImages = new Map();

        this.getImagesToSave = () => {
          const images = [];
          this.uploadedImages.forEach(image => {
            if (!image?.info?.id) {
              images.push({ 
                data: this.convertImageToBinary(image.data),
                fileName: image.fileName 
              });
            }
          });
          return images;
        };

        this.addImage = (data, info, fileName) => {
          const id = uuid.v4();
          this.uploadedImages.set(id, { data, info, fileName });
          this.placeholderArea.style.display = 'none';
          this.imageContainer.appendChild(
            this.renderImageBox(
              data, id, fileName
            )
          );
        };

        this.deleteImage = function(event) {
          const id = event.target.getAttribute('id');
          const imageBox = event.target.parentElement;
          const imageContainer = event.target.parentElement.parentElement;
          const image = this.uploadedImages.get(id);
          const callbackSuccess = () => {
            this.uploadedImages.delete(id);
            imageContainer.removeChild(imageBox);
            if (!this.uploadedImages.size) {
              this.imageViewer.destroy();
              this.placeholderArea.style.display = '';
            } else {
              this.setImageViewer();
            }
          }

          if (image?.info?.id) {
            try {

              new Function(
                'imageId',
                'callbackSuccess',
                this.meta.actionDelete
              )(image.info.id, callbackSuccess);
              
            } catch (error) {
              new Monet.Exception.ReturnError(this, "Maybe you need to add meta.actionDelete function to this field.")
                .console();
            }
          } else {
            callbackSuccess();
          }          
        };

        this.renderImageBox = (imageData, id) => {
          const container = document.createElement('div');
          const deleteImage = document.createElement('span');
          const image = document.createElement('img');

          deleteImage.className = 'button-delete';
          deleteImage.setAttribute('id', id);
          deleteImage.onclick = this.deleteImage.bind(this);

          image.src = imageData;

          container.className = 'image-box';
          container.appendChild(image);  
          container.appendChild(deleteImage); 

          return container;  
        }

        this.loadImages = (event) => {
          const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
          for(let i = 0; i < files.length; i++) {
            const file = files[i];

            if (this.validateFile(file)) {
              const reader = new FileReader();
              reader.onload = () => {
                this._removeErrorStyleFromContainer && this._removeErrorStyleFromContainer();
                this.addImage(reader.result, reader, file.name)
              }
              reader.readAsDataURL(file);
            }
          }
          setTimeout(this.setImageViewer, 500);
        };

        this.setValue = (images) => {
          if (images?.length) {
            this.handlerRenderImages(images);
          }
        };

        this.handlerRenderImages = data => {
          if (data?.length) {
            data.forEach(imageData => {
              const fileBase64 = `data:image/png;base64,${imageData.base64Thumbnail}`;
              this.addImage(fileBase64, imageData);
            });
            this.setImageViewer();
          }
        };

        this.triggerLoading = () => {
          const imageContainer = this.imageContainer;
          const placeholderText = this.placeholderText;

          if(imageContainer.className.includes('loading')) {
            imageContainer.classList.remove('loading');
            placeholderText.classList.remove('display-none');
          } else {
            imageContainer.classList.add('loading');
            placeholderText.classList.add('display-none');
          }
        };

        this.setImageViewer = () => {
          if (this.imageViewer) {
            this.imageViewer.destroy()
          }
          this.imageViewer = new Viewer(document.querySelector('.imageContainer'), {
            toolbar: {
                play: false,
                oneToOne: false,
                flipHorizontal: false,
                flipVertical: false,
                reset: { show: true, size: 'large' },
                rotateLeft: { show: true, size: 'large' },
                rotateRight: { show: true, size: 'large' },
                prev: { show: true, size: 'large' },
                next: { show: true, size: 'large' },
                zoomOut: { show: true, size: 'large' },
                zoomIn: { show: true, size: 'large' }
            },
            title: false
          });
        }

        this.addEventListeners = () => {
            this.hiddenInput.addEventListener('change', this.loadImages);

            this.chooseButton.addEventListener('click', () => {
                this.hiddenInput.click();
            });

            this.removeButton.addEventListener('click', () => {
                this.setImage('');
            });

            this.imageContainer.addEventListener("dragenter", () => {
                this.imageContainer.classList.add('onDrag');
            });

            this.imageContainer.addEventListener("dragleave", () => {
                this.imageContainer.classList.remove('onDrag');
            });

            this.imageContainer.addEventListener("dragover", (event) => {
                //Stop propagation and prevent default to allow drop
                event.stopPropagation();
                event.preventDefault();
            });

            this.imageContainer.addEventListener("drop", (event) => {
                event.preventDefault(); //prevent opening as link for some elements
                this.imageContainer.classList.remove('onDrag');
                this.loadImages(event);
            });
        };

        this.createButtonsContainer = () => {

            this.hiddenInput = document.createElement('input');
            this.hiddenInput.type = 'file';

            if(this.fileFormats.length) {
              this.hiddenInput.accept = '.' + this.fileFormats.join(',.');
            }
            this.hiddenInput.multiple = true;
            this.hiddenInput.style.display = 'none';
            this.rootEl.appendChild(this.hiddenInput);

            //Create 'Choose file' button
            this.chooseButton = document.createElement('span');
            this.chooseButton.className = 'chooseButton';
            this.chooseButton.innerText = Monet.I18n.getResourcesByKey('uploadField.chooseFile');

            //Create 'Remove' button
            this.removeButton = document.createElement('span');
            this.removeButton.className = 'removeButton';
            this.removeButton.innerText = Monet.I18n.getResourcesByKey('uploadField.removeFile');
            this.removeButton.style.display = this.image ? 'inline' : 'none';

            //Add both buttons to container
            this.buttonsContainer = document.createElement('div');
            this.buttonsContainer.className = 'buttonsContainer';
            this.buttonsContainer.appendChild(this.chooseButton);
            this.buttonsContainer.appendChild(this.removeButton);

            this.rootEl.appendChild(this.buttonsContainer);
        };

        this.createImageContainer = function () {

          this.placeholderArea = document.createElement('div');
          this.placeholderArea.className = 'placeholderArea';
          this.placeholderText = document.createElement('div');
          this.placeholderText.className = 'placeholderText';
          this.placeholderText.innerText = Monet.I18n.getResourcesByKey('uploadField.placeholderText');
          this.placeholderArea.appendChild(this.placeholderText);

          //Add both elements to container
          this.imageContainer = document.createElement('div');
          this.imageContainer.className = 'imageContainer';
          this.imageContainer.appendChild(this.placeholderArea);
          
          this.rootEl.appendChild(this.imageContainer);
        }

        this.removeLabelElement = function () {
          this.rootEl.firstChild.remove();
        };

        this.render = function () {

            this.fileFormats = this.meta?.fileFormats || ['jpg', 'jpeg'];
            this.maxFileSize = this.meta?.maxFileSize || 10;

            //Create field along with its elements and event listeners
            this.createBaseStructure();
            this.removeLabelElement();
            this.createImageContainer();
            this.createButtonsContainer();
            this.addEventListeners();
            this.rootEl.classList.add('imageUploadField');
            return this.rootEl;
        }

    }

    return MultipleImageUpload;

}());
